import React from 'react';
import { cn } from '@/lib/utils';
import { AnalysisProgressCircle } from './AnalysisProgressCircle';

interface AnalysisMinimizedIndicatorProps {
  progress: number;
  onClick: () => void;
  className?: string;
}

export function AnalysisMinimizedIndicator({
  progress,
  onClick,
  className,
}: AnalysisMinimizedIndicatorProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "fixed bottom-20 right-4 bg-white rounded-full p-4 shadow-lg",
        "hover:scale-110 transition-transform cursor-pointer",
        "animate-pulse",
        className
      )}
      aria-label="Analysis in progress - click to expand"
    >
      <div className="flex flex-col items-center justify-center">
        <AnalysisProgressCircle progress={progress} size={48} strokeWidth={4} />
        <span className="text-xs text-[#0D382A] text-center mt-1">
          {Math.round(progress)}%
        </span>
      </div>
    </button>
  );
}

